import { render, staticRenderFns } from "./Whistleblower.vue?vue&type=template&id=4191ef60&scoped=true"
import script from "./Whistleblower.vue?vue&type=script&lang=js"
export * from "./Whistleblower.vue?vue&type=script&lang=js"
import style0 from "./Whistleblower.vue?vue&type=style&index=0&id=4191ef60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4191ef60",
  null
  
)

export default component.exports